import styled from "styled-components"

export const LoginContentWrapper = styled.div`
    font-family: 'Roboto';
    border: 2px solid #D2D2D2;
    border-radius: 6px;
    max-width: 52em;
    min-width: 42em;
    padding: 0em 1em ;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`

export function LoginB2cLoading() {
    return(
        <LoginContentWrapper>
            <h3>Interconnect Customer Login</h3>
            <p>Authorizing...</p>        
        </LoginContentWrapper>
    )
}